import { FilterBuilder } from '../Types';

const registrationBuilder: FilterBuilder = ({ registration = [] }) => {
  if (
    registration.length === 0 ||
    (registration.includes('possible') && registration.includes('not-possible'))
  ) {
    return '';
  }

  return registration[0] === 'not-possible'
    ? 'facility_registration_possible:no'
    : 'facility_registration_possible:yes';
};

export default registrationBuilder;
